module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_cat_meow_19819.41b1a1ea.mp3";